import React from 'react';

const AuthForm = ({
  authMode,
  setAuthMode,
  authError,
  email,
  setEmail,
  password,
  setPassword,
  handleSignIn,
  handleSignUp,
  continueAsGuest,
}) => {
  return (
    <div className="login-container" style={{
      minHeight: '100vh',
      background: '#4FAEA5',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: '"Noto Sans SC", "PingFang SC", "Microsoft YaHei", sans-serif',
      padding: '20px',
    }}>
      {/* Responsive styles for login */}
      <style>{`
        .login-logo {
          width: 200px;
          height: 200px;
          margin-bottom: 24px;
        }
        .login-card {
          background: rgba(255,255,255,0.95);
          border-radius: 24px;
          padding: 40px;
          width: 100%;
          max-width: 400px;
          box-shadow: 0 10px 40px rgba(0,0,0,0.2);
          box-sizing: border-box;
        }
        .login-title {
          color: #1a1a2e;
          font-size: 28px;
          text-align: center;
          margin-bottom: 8px;
          margin-top: 0;
        }
        .login-subtitle {
          color: #64748b;
          text-align: center;
          margin-bottom: 32px;
          font-size: 14px;
        }
        .login-input {
          width: 100%;
          padding: 14px 16px;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          background: #f8fafc;
          color: #1a1a2e;
          font-size: 16px;
          margin-bottom: 12px;
          outline: none;
          box-sizing: border-box;
        }
        .login-input:last-of-type {
          margin-bottom: 16px;
        }
        .login-btn {
          width: 100%;
          padding: 14px;
          border-radius: 12px;
          border: none;
          font-size: 16px;
          cursor: pointer;
          box-sizing: border-box;
        }
        @media (max-width: 480px) {
          .login-container {
            padding-bottom: 80px;
          }
          .login-logo {
            width: 140px;
            height: 140px;
            margin-bottom: 16px;
          }
          .login-card {
            padding: 24px 20px;
            border-radius: 20px;
            max-width: calc(100% - 16px);
          }
          .login-title {
            font-size: 22px;
          }
          .login-subtitle {
            margin-bottom: 24px;
            font-size: 13px;
          }
          .login-input {
            padding: 12px 14px;
            font-size: 15px;
          }
          .login-btn {
            padding: 12px;
            font-size: 15px;
          }
        }
      `}</style>

      {/* Logo */}
      <img
        src={process.env.PUBLIC_URL + '/logo.png'}
        alt="Ripety - Learn Chinese"
        className="login-logo"
      />

      <div className="login-card">
        <h1 className="login-title">Welcome to Ripety</h1>
        <p className="login-subtitle">Learn Chinese, Fast & Fun!</p>

        {authError && (
          <div style={{
            background: authError.includes('Check your email') ? 'rgba(34,197,94,0.2)' : 'rgba(239,68,68,0.2)',
            color: authError.includes('Check your email') ? '#22c55e' : '#ef4444',
            padding: '12px',
            borderRadius: '8px',
            marginBottom: '16px',
            fontSize: '14px',
            textAlign: 'center',
          }}>{authError}</div>
        )}

        <form onSubmit={authMode === 'login' ? handleSignIn : handleSignUp}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
            style={{ marginBottom: '16px' }}
          />
          <button
            type="submit"
            className="login-btn"
            style={{
              background: '#4FAEA5',
              color: '#fff',
              fontWeight: '600',
              marginBottom: '12px',
            }}
          >
            {authMode === 'login' ? 'Sign In' : 'Sign Up'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginBottom: '16px', marginTop: '4px' }}>
          <button
            onClick={() => setAuthMode(authMode === 'login' ? 'signup' : 'login')}
            style={{
              background: 'none',
              border: 'none',
              color: '#4FAEA5',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            {authMode === 'login' ? "Don't have an account? Sign up" : 'Already have an account? Sign in'}
          </button>
        </div>

        <div style={{
          borderTop: '1px solid #e2e8f0',
          paddingTop: '16px',
          textAlign: 'center',
        }}>
          <button
            onClick={continueAsGuest}
            style={{
              background: 'none',
              border: 'none',
              color: '#94a3b8',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Continue as Guest (progress won't be saved)
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
